// 两种地图共用数量层级与颜色，聚合数量不代表设备在线状态。
export function clusterAppearance (value, accent) {
  const numeric = Number(value), count = Number.isFinite(numeric) ? Math.max(0, Math.floor(numeric)) : 0
  const size = count < 100 ? 36 : count < 10000 ? 44 : 52
  const short = (divisor, unit) => {
    const scaled = count / divisor
    return (scaled >= 100 ? String(Math.floor(scaled)) : (Math.floor(scaled * 10) / 10).toFixed(1).replace(/\.0$/, '')) + unit
  }
  return {
    count, size, label: count >= 1000000000000 ? short(1000000000000, '万亿') : count >= 100000000 ? short(100000000, '亿') : count >= 10000 ? short(10000, '万') : String(count),
    title: '该区域 ' + count + ' 台设备，点击放大查看',
    fill: 'rgba(8, 25, 36, 0.92)', border: accent || '#38bdf8', text: '#f0faff',
    shadow: 'rgba(0, 0, 0, 0.28)', fontSize: count < 100 ? 13 : 14,
    fontFamily: 'Arial, "Microsoft YaHei", sans-serif'
  }
}

// SDK内容使用安全DOM节点，不插入设备信息HTML；原生聚合点击/缩放仍由SDK处理。
export function clusterElement (appearance, ownerDocument = document) {
  const element = ownerDocument.createElement('div')
  element.className = 'device-map-cluster'
  element.textContent = appearance.label
  element.title = appearance.title
  element.setAttribute('aria-label', appearance.title)
  Object.assign(element.style, {
    boxSizing: 'border-box', width: appearance.size + 'px', height: appearance.size + 'px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    borderRadius: '50%', border: '1.5px solid', borderColor: appearance.border,
    backgroundColor: appearance.fill, color: appearance.text,
    boxShadow: '0 2px 8px ' + appearance.shadow + ', inset 0 0 0 3px rgba(255,255,255,0.06)',
    fontFamily: appearance.fontFamily, fontSize: appearance.fontSize + 'px', fontWeight: '600',
    fontVariantNumeric: 'tabular-nums', lineHeight: '1', whiteSpace: 'nowrap',
    cursor: 'pointer', userSelect: 'none', padding: '0', margin: '0'
  })
  return element
}
